import { apiClientWithRefreshToken } from "@/api/apiClient";

export default async function ExportSupplier({
    filter,
}: {
    filter?: Record<string, string>;
}) {
    return apiClientWithRefreshToken({
        url: "/suppliers/export",
        method: "GET",
        responseType: "blob",
        params: {
            ...filter,
        },
    });
}
